import Vue from "vue";
import Vuex from "vuex";
import salaryConcept from "../../models/conceptos/cSueldos";
import service from "../../services/modelosDeLiquidacion/rulesLiquidations";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    rulesLiquidations: [],
    paddingNav: "10px",
    open: false,
    mode: "",
    new: {},
    edit: {},
    itemDelete: null,
    openDelete: false,
    modeRelation: "",
    editRelation: {},
    openRelation: false,
    openDeleteRelation: false,
  },

  mutations: {
    setRulesLiquidations(state, data) {
      state.rulesLiquidations = data;
    },
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setOpen(state, data) {
      state.open = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setModeRelation(state, data) {
      state.modeRelation = data;
    },
    setEditRelation(state, data) {
      state.editRelation = data;
    },
    setOpenRelation(state, data) {
      state.openRelation = data;
    },
    setOpenDeleteRelation(state, data) {
      state.openDeleteRelation = data;
    },
  },
  actions: {
    async getRulesLiquidations(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getRulesLiquidations();
          state.commit("setRulesLiquidations", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getRulesLiquidationId({ state, commit }, id) {
      try {
        const data = await state.service.getRulesLiquidationId(id);
        commit("setEditRelation", data);
        return true;
      } catch (error) {
        throw error;
      }
    },
    async refreshTable({ state, commit }, id) {
      try {
        const data = await state.service.getRulesLiquidationId(id);
        commit("setEdit", data);
        return true;
      } catch (error) {
        throw error;
      }
    },
    async add(state) {
      try {
        const response = await state.state.service.add(state.state.new);
        const newItem = salaryConcept.fromJson(response.data);
        const updatedConcepts = [newItem, ...state.state.rulesLiquidations];
        state.commit("setRulesLiquidations", updatedConcepts);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.itemDelete).then(() => {
            let options = state.state.rulesLiquidations;
            options = options.filter((option) => {
              return option.id != state.state.itemDelete;
            });
            state.commit("setRulesLiquidations", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      try {
        const response = await state.state.service.edit(state.state.edit);
        if (response.status === 204) {
          let item = state.state.edit;
          let options = state.state.rulesLiquidations;
          if (options) {
            options = options.map((option) => {
              if (option.id !== item.id) {
                return option;
              }
            });
          }

          state.commit("setRulesLiquidations", options);

          return true;
        } else {
          return false;
        }
      } catch (error) {
        throw error;
      }
    },
    async addRuleDistribution(state) {
      try {
        const response = await state.state.service.addRuleDistribution(
          state.state.new
        );
        const newItem = response.data;

        state.state.edit.reglasLiqD.push(newItem);

        state.commit("setEdit", state.state.edit);

        return true;
      } catch (error) {
        throw error;
      }
    },
    editRuleDistribution(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editRuleDistribution(state.state.editRelation)
            .then(() => {
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    deleteRuleDistribution(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteRuleDistribution(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit;
              options.reglasLiqD = options.reglasLiqD.filter((option) => {
                return option.num !== state.state.itemDelete.orden;
              });
              state.commit("setEdit", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
